import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getMissingDataFeed: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchParams = '' } = args;

          const baseUrl = `${apiUrl.missingDataFeed}?perPage=${perPage || DEFAULT_PER_PAGE}&page=${
            page || DEFAULT_PAGE
          }`;

          return searchParams ? `${baseUrl}&${searchParams}` : baseUrl;
        }
        return `${apiUrl.missingDataFeed}`;
      },
      transformResponse: (responseData) => {
        const pagination = responseData?.pagination;
        const missingDataFeedIssues = responseData?.data?.missingDataFeeds || [];
        return { missingDataFeedIssues, pagination };
      },
      providesTags: ['MissingDataFeed'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetMissingDataFeedQuery, useLazyGetMissingDataFeedQuery } = extendedApi;
